
import React from 'react'
import DocumentMeta from 'react-document-meta'
import ReceiptHeader from './ReceiptHeader'
import ReceiptAddress from './ReceiptAddress'
import ReceiptFooter from './ReceiptFooter'
import ReceiptPayment from './ReceiptPayment'
import ReceiptStamp from './ReceiptStamp'
import Loader from 'ui/Loader'
import ShowHide from 'ui/ShowHide'
import css from './Receipt.module.css'

const Receipt = props => (
  <div className={css.main}>
    <DocumentMeta title='Receipt - Segment' />

    <ReceiptHeader />
    <ReceiptAddress />
    <ReceiptStamp />

    <Loader isLoading={props.isRequesting}>
      <ShowHide show={props.payment}>
        <ReceiptPayment
          workspaceSlug={props.params.workspaceSlug}
          billing={props.billing}
          payment={props.payment} />
      </ShowHide>
    </Loader>

    <ShowHide show={props.payment}>
      <ReceiptFooter payment={props.payment} />
    </ShowHide>
  </div>
)

export default Receipt



// WEBPACK FOOTER //
// ./components/Receipt.js